export default __webpack_public_path__ + "static/media/excel-o.2ddd62f7.svg";